<template>
    <div class="app-loader w-100 h-100">
        <div class="w-100 h-75 d-flex justify-content-center align-items-center">
            <div>
                <div class="d-flex justify-content-between mt-3">
                    <b-spinner
                        :variant="color"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'

export default {
    name: 'appLoader',
    mixins: [
        colorVariantMixin
    ],
    props: {
        variant: {
            type: String,
        }
    },
    data() {
        return {
            color: null,
            render1: false,
            render2: false,
        }
    },
    mounted() {
        // if we have no variant prop we use colorVariant from mixin
        this.color = this.variant || this.colorVariant;
        
    }
}
</script>